import {
  AUDIENCES_GET_REQUEST,
  AUDIENCES_GET_REQUEST_FAILED,
  AUDIENCES_GET_REQUEST_SUCCESS,
  AUDIENCE_ADD_REQUEST,
  AUDIENCE_ADD_REQUEST_FAILED,
  AUDIENCE_ADD_REQUEST_SUCCESS,
  AUDIENCE_EDIT_REQUEST,
  AUDIENCE_EDIT_REQUEST_FAILED,
  AUDIENCE_EDIT_REQUEST_SUCCESS,
  AUDIENCE_REMOVE_REQUEST,
  AUDIENCE_REMOVE_REQUEST_FAILED,
  AUDIENCE_REMOVE_REQUEST_SUCCESS,
  AUDIENCE_SEARCH_REQUEST,
  AUDIENCE_SEARCH_REQUEST_FAILED,
  AUDIENCE_SEARCH_REQUEST_SUCCESS,
  AUDIENCE_GET_PRESETS,
  AUDIENCE_GET_PRESETS_FAILED,
  AUDIENCE_GET_PRESETS_SUCCESS,
  AUDIENCE_GET_CATEGORIES,
  AUDIENCE_GET_CATEGORIES_FAILED,
  AUDIENCE_GET_CATEGORIES_SUCCESS,
  AUDIENCE_GET_SUBCATEGORIES,
  AUDIENCE_GET_SUBCATEGORIES_FAILED,
  AUDIENCE_GET_SUBCATEGORIES_SUCCESS,
  AUDIENCE_SUBCATEGORIES_CLEAR,
  AUDIENCE_GET_VARIABLES,
  AUDIENCE_GET_VARIABLES_FAILED,
  AUDIENCE_GET_VARIABLES_SUCCESS,
  AUDIENCE_VARIABLES_CLEAR,
  AUDIENCE_GET_COUNTRIES,
  AUDIENCE_GET_COUNTRIES_SUCCESS,
  AUDIENCE_GET_COUNTRIES_FAILED,
  AUDIENCE_GET_STATS,
  AUDIENCE_GET_STATS_FAILED,
  AUDIENCE_GET_STATS_SUCCESS,
  AUDIENCE_CLEAR_STATS,
  GET_REGIONS,
  GET_REGIONS_SUCCESS,
  GET_REGIONS_FAILED,
  GET_REGION_MAP,
  GET_REGION_MAP_SUCCESS,
  GET_REGION_MAP_FAILED,
  ADD_REGIONS,
  ADD_REGIONS_SUCCESS,
  ADD_REGIONS_FAILED,
  DELETE_INFO_REGIONS,
  DELETE_INFO_REGIONS_SUCCESS,
  DELETE_INFO_REGIONS_FAILED,
  DELETE_REGIONS,
  DELETE_REGIONS_SUCCESS,
  DELETE_REGIONS_FAILED,
  AUDIENCE_GET_MAP,
  AUDIENCE_GET_MAP_SUCCESS,
  AUDIENCE_GET_MAP_FAILED,
  AUDIENCE_GET_TAGS,
  AUDIENCE_GET_TAGS_FAILED,
  AUDIENCE_GET_TAGS_SUCCESS,
  AUDIENCE_CLEAR_TAGS,
  AUDIENCE_GET_DESCRIPTON,
  AUDIENCE_GET_DESCRIPTON_SUCCESS,
  AUDIENCE_GET_DESCRIPTON_FAILED,
  AUDIENCE_CLEAR_DESCRIPTION,
  AUDIENCE_GET_DEMOGRAPHICS,
  AUDIENCE_GET_DEMOGRAPHICS_SUCCESS,
  AUDIENCE_GET_DEMOGRAPHICS_FAILED,
  AUDIENCE_SET_AUDIENCES_OFFSET,
  AUDIENCE_SET_PRESETS_OFFSET,
  AUDIENCE_CLEAR_STATE_BEFORE_NEW_SEARCH,
  AUDIENCE_PRESETS_CLEAR,
  AUDIENCE_AUDIENCES_CLEAR,
  AUDIENCE_SAM_MAP_REQUEST,
  AUDIENCE_SAM_MAP_SUCCESS,
  AUDIENCE_SAM_MAP_FAILED,
  CLEAR_SAM_MAP_DATA,
  AUDIENCE_ATTACH_FILE_REQUEST,
  AUDIENCE_ATTACH_FILE_SUCCESS,
  AUDIENCE_ATTACH_FILE_FAILED,
  AUDIENCE_GET_AUDIENCE_BY_ID_REQUEST,
  AUDIENCE_GET_AUDIENCE_BY_ID_SUCCESS,
  AUDIENCE_GET_AUDIENCE_BY_ID_FAILED
} from "../../constants";

export const getAudiencesRequest = () => {
  return { type: AUDIENCES_GET_REQUEST };
};
export const addAudienceRequest = payload => {
  return { type: AUDIENCE_ADD_REQUEST, payload };
};
export const editAudienceRequest = payload => {
  return { type: AUDIENCE_EDIT_REQUEST, payload };
};
export const removeAudienceRequest = payload => {
  return { type: AUDIENCE_REMOVE_REQUEST, payload };
};
export const searchAudienceRequest = payload => {
  return { type: AUDIENCE_SEARCH_REQUEST, payload };
};
export const getPresetsRequest = () => {
  return { type: AUDIENCE_GET_PRESETS };
};
export const getCategoriesRequest = () => {
  return { type: AUDIENCE_GET_CATEGORIES };
};
export const getSubcategoriesRequest = () => {
  return { type: AUDIENCE_GET_SUBCATEGORIES };
};
export const getVariablesRequest = () => {
  return { type: AUDIENCE_GET_VARIABLES };
};

export const getAudiencesRequestFailed = payload => {
  return { type: AUDIENCES_GET_REQUEST_FAILED, payload };
};
export const addAudienceRequestFailed = payload => {
  return { type: AUDIENCE_ADD_REQUEST_FAILED, payload };
};
export const editAudienceRequestFailed = payload => {
  return { type: AUDIENCE_EDIT_REQUEST_FAILED, payload };
};
export const removeAudienceRequestFailed = payload => {
  return { type: AUDIENCE_REMOVE_REQUEST_FAILED, payload };
};
export const searchAudienceRequestFailed = payload => {
  return { type: AUDIENCE_SEARCH_REQUEST_FAILED, payload };
};
export const getPresetsRequestFailed = payload => {
  return { type: AUDIENCE_GET_PRESETS_FAILED, payload };
};
export const getCategoriesRequestFailed = payload => {
  return { type: AUDIENCE_GET_CATEGORIES_FAILED, payload };
};
export const getSubcategoriesRequestFailed = payload => {
  return { type: AUDIENCE_GET_SUBCATEGORIES_FAILED, payload };
};
export const getVariablesRequestFailed = payload => {
  return { type: AUDIENCE_GET_VARIABLES_FAILED, payload };
};

export const getAudiencesRequestSuccess = payload => {
  return { type: AUDIENCES_GET_REQUEST_SUCCESS, payload };
};
export const addAudienceRequestSuccess = payload => {
  return { type: AUDIENCE_ADD_REQUEST_SUCCESS, payload };
};
export const editAudienceRequestSuccess = payload => {
  return { type: AUDIENCE_EDIT_REQUEST_SUCCESS, payload };
};
export const removeAudienceRequestSuccess = payload => {
  return { type: AUDIENCE_REMOVE_REQUEST_SUCCESS, payload };
};
export const searchAudienceRequestSuccess = payload => {
  return { type: AUDIENCE_SEARCH_REQUEST_SUCCESS, payload };
};

export const getPresetsRequestSuccess = payload => {
  return { type: AUDIENCE_GET_PRESETS_SUCCESS, payload };
};
export const getCategoriesRequestSuccess = payload => {
  return { type: AUDIENCE_GET_CATEGORIES_SUCCESS, payload };
};
export const getSubcategoriesRequestSuccess = payload => {
  return { type: AUDIENCE_GET_SUBCATEGORIES_SUCCESS, payload };
};
export const getVariablesRequestSuccess = payload => {
  return { type: AUDIENCE_GET_VARIABLES_SUCCESS, payload };
};
export const audienceSubcategoriesClear = () => {
  return { type: AUDIENCE_SUBCATEGORIES_CLEAR };
};
export const audienceVariablesClear = () => {
  return { type: AUDIENCE_VARIABLES_CLEAR };
};

export const getCountries = payload => {
  return { type: AUDIENCE_GET_COUNTRIES, payload };
};
export const getCountriesSuccess = payload => {
  return { type: AUDIENCE_GET_COUNTRIES_SUCCESS, payload };
};
export const getCountriesFailed = payload => {
  return { type: AUDIENCE_GET_COUNTRIES_FAILED, payload };
};

export const getMaps = payload => {
  return { type: AUDIENCE_GET_MAP, payload };
};
export const getMapsSuccess = payload => {
  return { type: AUDIENCE_GET_MAP_SUCCESS, payload };
};
export const getMapsFailed = payload => {
  return { type: AUDIENCE_GET_MAP_FAILED, payload };
};

export const getTags = payload => {
  return { type: AUDIENCE_GET_TAGS, payload };
};
export const getTagsSuccess = payload => {
  return { type: AUDIENCE_GET_TAGS_SUCCESS, payload };
};
export const getTagsFailed = payload => {
  return { type: AUDIENCE_GET_TAGS_FAILED, payload };
};
export const clearTags = () => {
  return { type: AUDIENCE_CLEAR_TAGS };
};

export const getStats = payload => {
  return { type: AUDIENCE_GET_STATS, payload };
};
export const getStatsSuccess = payload => {
  return { type: AUDIENCE_GET_STATS_SUCCESS, payload };
};
export const getStatsFailed = payload => {
  return { type: AUDIENCE_GET_STATS_FAILED, payload };
};

export const getRegions = payload => {
  return { type: GET_REGIONS, payload };
};
export const getRegionsSuccess = payload => {
  return { type: GET_REGIONS_SUCCESS, payload };
};
export const getRegionsFailed = payload => {
  return { type: GET_REGIONS_FAILED, payload };
};

export const getRegionMap = payload => {
  return { type: GET_REGION_MAP, payload };
};
export const getRegionMapSuccess = payload => {
  return { type: GET_REGION_MAP_SUCCESS, payload };
};
export const getRegionMapFailed = payload => {
  return { type: GET_REGION_MAP_FAILED, payload };
};

export const addRegion = payload => {
  return { type: ADD_REGIONS, payload };
};
export const addRegionSuccess = payload => {
  return { type: ADD_REGIONS_SUCCESS, payload };
};
export const addRegionFailed = payload => {
  return { type: ADD_REGIONS_FAILED, payload };
};

export const deleteInfoRegion = payload => {
  return { type: DELETE_INFO_REGIONS, payload };
};
export const deleteInfoRegionSuccess = payload => {
  return { type: DELETE_INFO_REGIONS_SUCCESS, payload };
};
export const deleteInfoRegionFailed = payload => {
  return { type: DELETE_INFO_REGIONS_FAILED, payload };
};

export const deleteRegion = payload => {
  return { type: DELETE_REGIONS, payload };
};
export const deleteRegionSuccess = payload => {
  return { type: DELETE_REGIONS_SUCCESS, payload };
};
export const deleteRegionFailed = payload => {
  return { type: DELETE_REGIONS_FAILED, payload };
};

export const clearStats = () => {
  return { type: AUDIENCE_CLEAR_STATS };
};

export const getDescription = payload => {
  return { type: AUDIENCE_GET_DESCRIPTON, payload };
};
export const getDescriptionSuccess = payload => {
  return { type: AUDIENCE_GET_DESCRIPTON_SUCCESS, payload };
};
export const getDescriptionFailed = payload => {
  return { type: AUDIENCE_GET_DESCRIPTON_FAILED, payload };
};
export const clearDescription = () => {
  return { type: AUDIENCE_CLEAR_DESCRIPTION };
};

export const getDemographics = payload => {
  return { type: AUDIENCE_GET_DEMOGRAPHICS, payload };
};
export const getDemographicsSuccess = payload => {
  return { type: AUDIENCE_GET_DEMOGRAPHICS_SUCCESS, payload };
};
export const getDemographicsFailed = payload => {
  return { type: AUDIENCE_GET_DEMOGRAPHICS_FAILED, payload };
};

// For lomit & offset
export const setAudiencesPaginationOffset = payload => {
  return { type: AUDIENCE_SET_AUDIENCES_OFFSET, payload };
};
export const setPresetsPaginationOffset = payload => {
  return { type: AUDIENCE_SET_PRESETS_OFFSET, payload };
};

// For backend search and filters
export const clearStateBeforeSearchRequest = () => {
  return { type: AUDIENCE_CLEAR_STATE_BEFORE_NEW_SEARCH };
};

// Clear presets

export const clearPresets = () => {
  return { type: AUDIENCE_PRESETS_CLEAR };
};

export const clearAudiences = () => {
  return { type: AUDIENCE_AUDIENCES_CLEAR };
};

// SAM map

export const getSamMapDataRequest = () => {
  return { type: AUDIENCE_SAM_MAP_REQUEST };
};

export const getSamMapDataSuccess = payload => {
  return { type: AUDIENCE_SAM_MAP_SUCCESS, payload };
};

export const getSamMapDataFailed = payload => {
  return { type: AUDIENCE_SAM_MAP_FAILED, payload };
};

export const clearSamMapData = () => {
  return { type: CLEAR_SAM_MAP_DATA };
};

// For attach file
export const attachFileRequest = () => {
  return { type: AUDIENCE_ATTACH_FILE_REQUEST };
};

export const attachFileSuccess = payload => {
  return { type: AUDIENCE_ATTACH_FILE_SUCCESS, payload };
};

export const attachFileFailed = payload => {
  return { type: AUDIENCE_ATTACH_FILE_FAILED, payload };
};

// Get audience by id
export const getAudienceByIdRequest = () => {
  return { type: AUDIENCE_GET_AUDIENCE_BY_ID_REQUEST };
};

export const getAudienceByIdSuccess = payload => {
  return { type: AUDIENCE_GET_AUDIENCE_BY_ID_SUCCESS, payload };
};

export const getAudienceByIdFailed = payload => {
  return { type: AUDIENCE_GET_AUDIENCE_BY_ID_FAILED, payload };
};
